export const CheckIcon = () => {
  return (
    <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="CheckMark Referrals">
        <path
          id="Ellipse 1"
          d="M60 30C60 46.5685 46.5685 60 30 60C13.4315 60 0 46.5685 0 30C0 13.4315 13.4315 0 30 0C46.5685 0 60 13.4315 60 30Z"
          fill="#27AE60"
        />
        <g id="Vector">
          <path
            d="M22.8896 38.5607L15.1124 30.8878C14.2458 30.0329 12.8681 30.0329 12.0015 30.8878C11.1349 31.7428 11.1349 33.102 12.0015 33.957L21.312 43.1425C22.1786 43.9975 23.5785 43.9975 24.4451 43.1425L47.9989 19.9266C48.8655 19.0716 48.8655 17.7124 47.9989 16.8574C47.1323 16.0024 45.7546 16.0024 44.888 16.8574L22.8896 38.5607Z"
            fill="white"
          />
          <path
            d="M22.8896 38.5607L15.1124 30.8878C14.2458 30.0329 12.8681 30.0329 12.0015 30.8878C11.1349 31.7428 11.1349 33.102 12.0015 33.957L21.312 43.1425C22.1786 43.9975 23.5785 43.9975 24.4451 43.1425L47.9989 19.9266C48.8655 19.0716 48.8655 17.7124 47.9989 16.8574C47.1323 16.0024 45.7546 16.0024 44.888 16.8574L22.8896 38.5607Z"
            stroke="white"
          />
        </g>
      </g>
    </svg>
  )
}
